import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=15b1e34b"
import script from "./attachments.vue?vue&type=script&lang=js"
export * from "./attachments.vue?vue&type=script&lang=js"
import style0 from "./attachments.vue?vue&type=style&index=0&id=15b1e34b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports